import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import * as actionsCreators from  '../../store/actions/index';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell'; 
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ReactPaginate from 'react-paginate';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
class AreaListing extends React.Component {
    state = {
        areaId:'',
        open:false,
        anchorEl:null,
        limit: 10,
    }

    componentDidMount(){
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
        }
        this.props.onFetchAreaList(payload);
        this.props.onfetchAreaHeaders(payload);
    }

    handleActionButtonClick = (event,areaId)=>{
        this.setState({open:!this.state.open,anchorEl:event.currentTarget,areaId})
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
        }
        this.props.onFetchAreaList(payload)
    };

    render() {
        let updatedHeaders = this.props.AreaHeader
        const AreaHeaderList = updatedHeaders.map((item)=>{
            return (  <TableCell  className={"white-space"}>
            <div style={{
                    display: 'flex',
                    alignItems: 'start',
                    whiteSpace: 'break-spaces',
                    height:'3em'
                    }}>
                      {item.header}
            </div>
        </TableCell>)
        })
        const Areas=this.props.area.map((area, j)=>{
            const areaId=area["Id"]
            return <TableRow style={{whiteSpace: 'normal',
            wordWr: 'break-word'}} key={j}>{
            updatedHeaders.map((header, i)=>{
                if(header.accessor=='actionButton'){
                 return  <TableCell  key={i}>
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={(e)=>this.handleActionButtonClick(e,areaId)}
                    >
                    <MoreVertIcon fontSize='small'/>
                    </IconButton>
                        <Popper
                        open={this.state.open} anchorEl={this.state.anchorEl}>
                        <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                        <Paper style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                            <MenuList>
                                <Link to={`./edit_area/${this.state.areaId}`} className='email_link'> <MenuItem>Edit</MenuItem></Link>
                            </MenuList>
                            <MenuList>
                            {/* <Link to={`./property_loads/${this.state.areaId}`} className='email_link'> <MenuItem>Show Loads</MenuItem></Link> */}
                            </MenuList>
                        </Paper>
                        </ClickAwayListener>
                    </Popper>
                </TableCell>
                }
                else{
                    return  <TableCell style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word"
                    }} key={i} className={"white-space"}>{area[header.accessor] == null || area[header.accessor] == 'null' ? ' ' : area[header.accessor]}</TableCell>
                }
               }) 
            }
         </TableRow>
        })
        return (
            <div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                    <div className="dashboard_right_content_top">
                        <h5>Area Listing</h5>
                        <div className="dashboard_right_content_top_options">
                            <Link className="email_link" to="add_area"><Button>Add a New Area</Button></Link> 
                        </div>
                    </div>

                    <div className="dashboard_listing AreaLIsting" >
                        <TableContainer component={Paper} style={{paddingLeft:"15px",paddingRight:"15px"}}>
                             <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                                <TableHead >
                                    <TableRow >
                                        {AreaHeaderList}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                 {Areas}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                {
                this.props.totalCount && this.props.totalCount != 0 && 
                    <ReactPaginate
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount = {10}
                    pageCount = {this.props.totalCount/this.state.limit}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    style={{borderLeftWidth:'0px'}}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}/>
                }
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        token: state.auth.token,
        area:state.areaListing.area,
        totalCount:state.areaListing.totalCount,
        AreaHeader: state.AreaHeader.AreaHeaders ? state.AreaHeader.AreaHeaders.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "true"}) :[],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchAreaList: (onFetchAreaList) => dispatch(actionsCreators.AreaList(onFetchAreaList)),
        onfetchAreaHeaders:(payload)=>dispatch(actionsCreators.fetchAreaHeaders(payload))

    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(AreaListing);
